import React from "react";
import { useDropzone } from "react-dropzone";
import { useState, useCallback, useEffect } from "react";

import { imageUploaderContainer, previewImage } from "./image-uploader.module.scss";

const activeStyle: React.CSSProperties = {
  borderColor: "#CF60C8",
};


interface IImageUploaderProps {
    imageUrl?: string;
    onUploadPhoto?(file:File): void;
}


const ImageUploader: React.FC<IImageUploaderProps> = ({
  imageUrl = "",
  onUploadPhoto
}) => {
  const [preview, setPreview] = useState<string | null>(null);

  const onDrop = useCallback((acceptedFiles: File[]) => {
    const file = acceptedFiles[0];
    const previewUrl = URL.createObjectURL(file);
    setPreview(previewUrl);
    if (onUploadPhoto) {
      onUploadPhoto(file);
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { "image/*": [] },
    multiple: false,
  });

  const style = {
    ...(isDragActive ? activeStyle : {}),
  };
  // zwolnij URL po odmontowaniu komponentu
  useEffect(() => {
    return () => preview && URL.revokeObjectURL(preview);
  }, [preview]);

  useEffect(() => {
    if (imageUrl && imageUrl !== "") {
      setPreview(imageUrl);
    }
  }, []);
  useEffect(() => {
    if (imageUrl && imageUrl !== "") {
      setPreview(imageUrl);
    }
  }, [imageUrl]);

  return (
    <div {...getRootProps()} className={`dropzone ${imageUploaderContainer}`} style={style}>
      <input {...getInputProps()} />
      {isDragActive ? (
        <p>Upuść plik tutaj...</p>
      ) : (
        <p>Przeciągnij lub kliknij, aby wybrać wgrać swoje zdjęcie</p>
      )}
      {preview && <img className={previewImage} src={preview} alt="Podgląd" />}
    </div>
  );
}
export default ImageUploader;
